export const formatDate = (datetime, showTime = false, locale = "en-US") => {
  const date = new Date(datetime);

  const timeProps = { hour: "numeric", minute: "numeric" };
  const options = {
    year: "numeric",
    day: "numeric",
    month: "numeric",
  };
  const dateTimeFormat = new Intl.DateTimeFormat(
    locale,
    showTime ? { ...options, ...timeProps } : options
  );
  return dateTimeFormat.format(date);
};
